export class DashboardDate {
  static inputValue(date: Date): string {
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0'),
    ].join('-');
  }

  static fromInput(value: string): Date | null {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match) return null;

    const year = Number(match[1]);
    const month = Number(match[2]) - 1;
    const day = Number(match[3]);
    const date = new Date(year, month, day, 12);

    if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) return null;
    return date;
  }

  static defaultRange(today: Date): { from: string; to: string } {
    const previousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1, 12);
    const lastDay = new Date(today.getFullYear(), today.getMonth(), 0, 12).getDate();
    previousMonth.setDate(Math.min(today.getDate(), lastDay));
    return { from: DashboardDate.inputValue(previousMonth), to: DashboardDate.inputValue(today) };
  }

  static isInRange(value: string | null | undefined, from: string, to: string): boolean {
    if (!value) return false;
    const date = value.slice(0, 10);
    return from <= date && date <= to;
  }

  static periodCountBetween(from: Date, to: Date, period: 'day' | 'week' | 'month'): number {
    if (period === 'month') {
      return Math.max(1, (to.getFullYear() - from.getFullYear()) * 12 + to.getMonth() - from.getMonth() + 1);
    }

    const day = 86_400_000;
    if (period === 'day') return Math.max(1, Math.round((to.getTime() - from.getTime()) / day) + 1);

    const monday = (date: Date) => new Date(date.getTime() - ((date.getDay() + 6) % 7) * day);
    return Math.max(1, Math.round((monday(to).getTime() - monday(from).getTime()) / (7 * day)) + 1);
  }
}
